import "./lastModification.service";

class LastModificationFilter {

    public static $inject: string[] = ["lastModification"];

    constructor(lastModification) {
        return (date, parameters) => {
            return lastModification.formattedLapseOfTime(date, parameters);
        };
    }
}

angular
    .module("thor.core.dates.lastModification.filter", [
        "thor.core.dates.lastModification.service"
    ])
    .filter("lastModification", <any>LastModificationFilter);
